export const VEHICLE_PROPERTIES = Object.freeze({
  MAKE: 'MAKE',
  YEAR: 'YEAR',
  MODEL: 'MODEL',
  MILEAGE: 'MILEAGE',
  REG_DATE: 'REG_DATE'
});

export const VEHICLE_VALUES = Object.freeze({
  OTHER: 'OTHER',
  ANY: 'ANY'
});

export const VEHICLE_TRIM = Object.freeze({
  TRIM: 'TRIM',
  TRANSMISSION: 'TRANSMISSION',
  DRIVE_TYPE: 'DRIVE_TYPE',
  ENGINE_TYPE: 'ENGINE_TYPE',
  ENGINE_SIZE: 'ENGINE_SIZE'
});

export const VEHICLE_TRIM_DATA = Object.freeze([
  'trim',
  'engineType',
  'engineSize',
  'driveType',
  'transmissionType'
]);

export const I_DONT_KNOW = "I DON'T KNOW";

export const LANES = [
  VEHICLE_PROPERTIES.MAKE,
  VEHICLE_PROPERTIES.YEAR,
  VEHICLE_PROPERTIES.MODEL,
  VEHICLE_TRIM.TRANSMISSION,
  VEHICLE_TRIM.DRIVE_TYPE,
  VEHICLE_TRIM.TRIM,
  VEHICLE_TRIM.ENGINE_TYPE,
  VEHICLE_TRIM.ENGINE_SIZE,
  VEHICLE_PROPERTIES.MILEAGE
];

export const LANES_WITHOUT_TRIM = [
  VEHICLE_PROPERTIES.MAKE,
  VEHICLE_PROPERTIES.YEAR,
  VEHICLE_PROPERTIES.MODEL,
  VEHICLE_TRIM.TRANSMISSION,
  VEHICLE_TRIM.DRIVE_TYPE,
  VEHICLE_TRIM.ENGINE_TYPE,
  VEHICLE_TRIM.ENGINE_SIZE,
  VEHICLE_PROPERTIES.MILEAGE
];

export const SPECIAL_MAKE_LABELS = {
  SKODA: 'ŠKODA'
};



// WEBPACK FOOTER //
// ./src/constants/vehicle.js